import React from "react";
import Styled from "styled-components";
import Doc from "../asset/Mayank_bhugra.pdf" ;
function PersonalInfo() {
  let age = new Date().getFullYear();
  return (
    <MainCont>
      <InnerMain>
        <Heading>Personal Info</Heading>
        <OuterDiv>
          <InnerDiv>
            <ul>
              <li>
                First Name: <strong>Mayank</strong>
              </li>
              <li>
                Age: <strong>{age-2000}</strong>
              </li>
              <li>
                Phone: <strong>+91 9313415766</strong>
              </li>
              <li>
                Languages: <strong>Hindi, English</strong>
              </li>
            </ul>
          </InnerDiv>
          <InnerDiv>
            <ul>
              <li>
                Last Name: <strong>Bhugra</strong>
              </li>
              <li>
                Nationality: <strong>Indian</strong>
              </li>
              <li>
                Address: <strong>661/21 Faridabad, Haryana</strong>
              </li>
              <li>
                Email: <strong>bhugramayank@gmail.com</strong>
              </li>
            </ul>
          </InnerDiv>
        </OuterDiv>
      </InnerMain>
      <Download>
        <Btn href={Doc} download>
          Download CV
          <Colapse>
            <i className="fas fa-arrow-down"></i>
          </Colapse>
        </Btn>
      </Download>
    </MainCont>
  );
}
const MainCont = Styled.div`
    display:flex;
    justify-content:space-between;
    @media (max-width:768px){
      flex-direction:column;
      align-items:center;
      gap:2rem;
    }
`;
const InnerMain = Styled.div`
    width:50%;
    @media (max-width:768px){
      width:100%;
      display:flex;
      flex-direction:column;
      align-items:center;
    }
`;
const Heading = Styled.span`
    color:white;
    font-size:30px;
    font-family:sans-serif;
    font-weight:550;
    letter-spacing:1px;
    display:block;
    text-align:left;
    margin-bottom:1rem;
    @media (max-width:768px){
      text-align:center;
    }
    @media (max-width:425px){
      font-size:25px;
    }
`;
const OuterDiv = Styled.div`
    display:flex;
    gap:4rem;
    // justify-content:center;
    @media (max-width:768px){
      gap:1rem;
    }
`;
const InnerDiv = Styled.div`
    color:white;
    strong{
        color:#ffb400;
    }
    ul{
        display:flex;
        flex-direction:column;
        gap:1.5rem;
        list-style:none;
        padding:0;
    }
    @media (max-width:768px){
      width:50%;
    }
    @media (max-width:425px){
      font-size:15px;
    }
`;
const Download = Styled.div`
  width:50%;
  display:flex;
  justify-content:center;
  align-items:center;
  font-family:sans-serif;
  `;
  const Btn = Styled.a`
    border:2px solid #ffb400;
    border-radius:100px;
    height:3.5rem;
    font-size:20px;
    background:transparent;
    color:white;
    padding-left:1rem;
    padding-right:0;
    font-weight:600;
    z-index:5;
    text-decoration:none;
    cursor:pointer;
    display:flex;
    justify-content:space-between;
    align-items:center;
    &:hover{
        transition:1s all;
        background-color:#ffb400;
    }
    @media (max-width:425px){
      font-size:0.85rem;
      height:3rem;
    }
`;
const Colapse = Styled.span`
  border-radius:50%;
  height:50px;
  width:50px;
  z-index:1;
  justify-content:center;
  align-items:center;
  display:flex;
  position:relative;
  color:white;
  background:#ffb400;
  border:2px solid #ffb400;
  margin-left:15px;
  pointer-events:none;
  cursor:pointer;
  @media (max-width:425px){
    font-size:0.9rem;
    height:3rem;
    width:3rem;
  }
`;
export default PersonalInfo;
